module.exports = __webpack_public_path__ + "static/img/books.3c15469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/books.jpg
// module id = jk0I
// module chunks = 1